export default function CampusMapMarker({ facility, isSelected, onSelect }) {
  const markerStyle = {
    left: `${facility.x}%`,
    top: `${facility.y}%`,
  };

  return (
    <button
      aria-label={`View ${facility.name} details`}
      aria-pressed={isSelected}
      className={`campus-zone ${isSelected ? "is-selected" : ""}`}
      data-testid={`campus-map-zone-${facility.id}`}
      onClick={() => onSelect(facility.id)}
      style={markerStyle}
      type="button"
    >
      <span aria-hidden="true">{facility.marker}</span>
    </button>
  );
}